import { setSettingsCookie } from '@js/globalFunctions/cookieHandling'

export function updateSelectedChangedays( selectedChangedayHolder )
{
	resetSelectedChangeDays();
	var inputLength 		= $('.changeDateSelectInput').length;
	var selectedLength 		= selectedChangedayHolder.length;
	var selectedString 		= '';

	for( var i = 0; i < selectedLength; i++ )
	{
		$('.changeDateSelectInput[data-key='+selectedChangedayHolder[i]+']').prop('checked',true);
		selectedString += selectedChangedayHolder[i]+',';
	}

	if( (selectedLength+1) === inputLength )
	{
		$('.selectAllChangeDateInputs').prop('checked', true);
	}

	var noneSelected = false;
	if( typeof dataholder.mtm_settings.noChangeDaySelected !== 'undefined' && dataholder.mtm_settings.noChangeDaySelected === true )
	{
		noneSelected = true;
	}

	if( !$('select[name=skiftedag]').hasClass('highlight') )
	{
		$('select[name=skiftedag]').addClass('highlight');
	}

	if( selectedLength === 0 )
	{
		updateChangedaySelectText( selectedChangedayHolder );
		if( dataholder.prevChangedayHolder === false && noneSelected !== true )
		{
			var els = $('.changeDateSelectInput');
			for( var i = 0; i < inputLength; i++ )
			{
				$(els[i]).prop('checked',true);
			}
		}
		else
		{
			searchParameters.removeParameter('skiftedag')
			setSettingsCookie('noChangeDaySelected', true);
		}
	}
	else
	{
		setSettingsCookie('noChangeDaySelected', false);

		updateChangedaySelectText( selectedChangedayHolder );
		if( (selectedLength+1) === inputLength )
		{
			searchParameters.removeParameter('skiftedag')
			$('.selectAllChangeDateInputs').prop('checked', true);
		}
		else
		{
			selectedString = selectedString.slice(0, -1);
			searchParameters.setParameter('skiftedag',selectedString)
		}
	}
	dataholder.prevChangedayHolder = selectedChangedayHolder;
}

function resetSelectedChangeDays()
{
	var els = $('.changeDateSelectInput');

	for( var i = 0; i < els.length; i++ )
	{
		$(els[i]).prop('checked',false);
	}
}

function updateChangedaySelectText( selectedChangedayHolder )
{
	var inputLength 		= $('.changeDateSelectInput').length;
	var selectedLength 		= selectedChangedayHolder.length;

	if( selectedLength === 0 ){
		$('select[name=skiftedag] option[value=none]').text(wpTranslatedStrings.terms.changedayAll);
	}
	else
	{
		if( (selectedLength+1) === inputLength )
		{
			$('select[name=skiftedag] option[value=none]').text(wpTranslatedStrings.terms.changedayAll);
		}
		else
		{
			var modString = '';

			for( var i = 0; i < selectedLength; i++ )
			{
				modString += $('select[name=skiftedag] option[value='+selectedChangedayHolder[i]+']').text() + ', ';
			}
			modString = modString.slice(0, -2);
			$('select[name=skiftedag] option[value=none]').text(modString);
		}
	}
}
